import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from 'react-to-print';
import Select from 'react-select'
import moment from "moment";

// components
import {
    Button,
    FormGroup,
    Input,
    Modal,
    Row,
    Col,
    Spinner
} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faPlus, faSquarePlus } from "@fortawesome/free-solid-svg-icons";


// helpers
import { formateDateandTime } from "../../helpers/formats.js";


// services
import { getSessionCookie } from "../../services/session.js";
import { api_GET, api_PUT } from "../../services/api_service.js";
import { showMessage } from "../../services/message.js";

//Componentes
import ModalViaComprovanteDescarregamento from "../admin/avaliacao-os/ModalViaComprovanteDescarregamento.jsx";
import ModalAdicionarInconformidade from "./ModalAdicionarInconformidade.jsx";


export default function ModalAcoesColetor({ stateModalAcoesColetor, ordemColeta, handleReturn, ordemColetaAcaoColetorId }) {
    const session = getSessionCookie();
    const [stateModal, setstateModal] = React.useState(stateModalAcoesColetor);
    const refImprimir = useRef();

    const [showLoading, setshowLoading] = useState(false);

    //Função assionada assim que o botão de imprimir é clicado
    const handlePrint = useReactToPrint({
        content: () => refImprimir.current,
        copyStyles: true,
        documentTitle: "Relatório detalhado por transportador",
        pageStyle: `
        @media print {
            * { overflow: visible !important; }     
            html, body{
                height:100%;         
                margin: 0 !important; 
                padding: 0 !important;
            }
            .allowPrint, .allowPrint *{
              visibility: visible;      
            }
            .allowPrint {
                position: absolute;
                width:100%;
                left: 0;
                top: 0 !important;
                max-width: 100%!important;
                border:none!important;
                margin: 0px !important;  
                padding-left: 0px !important;
                padding-right: 0px !important;      
            }
            .no-print, .no-print *
            {
                display: none !important;
                margin:0px !important;
                padding: 0px !important;
            }
            .md-chat-widget-btn-container{
                display:none
            }
        
            .page-break {
                page-break-inside: avoid;
            }
        
            .Column-table {
                display: none;
            }
        
            .btn-invisivel {
                display: none;
            }
          }
        `
    });

    const [optionsQualidadeExecucao, setOptionsQualidadeExecucao] = useState([]);

    const loadoptionsQualidadeExecucao = (modalidadeColetaId) => {
        api_GET(`IndiceQualidade/GetListByModalidade/${modalidadeColetaId}`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setOptionsQualidadeExecucao(result.data);
            }
        });
    }

    const [acoes, set_acoes] = React.useState([]);
    const handleLoadAcoes = () => {
        let _acoes = [];

        if (ordemColeta != null) {
            ordemColeta.ordemColetaAcaoColetor.filter(f => f.ordemColetaAcaoColetorId == ordemColetaAcaoColetorId || ordemColetaAcaoColetorId == null).map(item => {
                let _evidencias = [];
                item.ordemColetaAcaoColetorEvidencia.map(m => {
                    _evidencias.push(m);
                });

                _acoes.push({
                    tipoAcao: item.tipoAcao,
                    dataHoraExecucao: item.dataHoraExecucao,
                    ordemColetaExecucao: null,
                    justificativa: item.justificativa != null ? item.justificativa : null,
                    descricao: handleObservacao(item),
                    evidenciasAcao: _evidencias,
                    tempoExecucaoMinutos: null,
                    comprovantes: item.ordemColetaDestinacao.length > 0 ? item.ordemColetaDestinacao[0].ordemColetaDestinacaoComprovante : [],
                    ordemColetaDestinacaoId: item?.ordemColetaDestinacao[0]?.ordemColetaDestinacaoId,
                    latitude: item.latitude,
                    longitude: item.longitude,
                    ordemColetaPontoColetaId: null,
                    ordemColetaAcaoColetorId: item.ordemColetaAcaoColetorId,
                    ordemColetaPontoColetaAlteracoes: [],
                    ordemColetaAcaoColetorLogAlteracao: item.ordemColetaAcaoColetorLogAlteracoes
                });
            });

            if (ordemColetaAcaoColetorId == null) {
                ordemColeta.ordemColetaPontoColeta.filter(f => f.statusColeta != "Programada").map(ordemColetaPonto => {
                    let _ordemColetaExecucao = {
                        ordemColetaExecucaoId: null,
                        evidenciasAntes: [],
                        evidenciasDepois: [],
                        tempoExecucaoMinutos: null,
                        qualidadeExecucao: 0
                    }

                    if (ordemColetaPonto != null && ordemColetaPonto.ordemColetaExecucao != null) {

                        for (var i in ordemColetaPonto.ordemColetaExecucao) {
                            ordemColetaPonto.ordemColetaExecucao[i].ordemColetaExecucaoEvidencia.filter(f => f.momentoEvidencia == "Antes").map(m => {
                                _ordemColetaExecucao.evidenciasAntes.push(m);
                            });
                            ordemColetaPonto.ordemColetaExecucao[i].ordemColetaExecucaoEvidencia.filter(f => f.momentoEvidencia == "Depois").map(m => {
                                _ordemColetaExecucao.evidenciasDepois.push(m);
                            });

                            _ordemColetaExecucao.ordemColetaExecucaoId = ordemColetaPonto.ordemColetaExecucao[i].ordemColetaExecucaoId;
                            _ordemColetaExecucao.tempoExecucaoMinutos = ordemColetaPonto.ordemColetaExecucao[i].tempoExecucaoMinutos;
                            _ordemColetaExecucao.qualidadeExecucao = ordemColetaPonto.ordemColetaExecucao[i]?.qualidadeExecucao;
                        }
                    }

                    _acoes.push({
                        tipoAcao: ordemColetaPonto.statusColeta,
                        dataHoraExecucao: ordemColetaPonto.ordemColetaExecucao != null && ordemColetaPonto.ordemColetaExecucao.length > 0 && ordemColetaPonto.ordemColetaExecucao[0].dataHoraExecucao,
                        justificativa: (ordemColetaPonto.ordemColetaExecucao != null && ordemColetaPonto.ordemColetaExecucao.length > 0 && ordemColetaPonto.ordemColetaExecucao[0].justificativa != null) ? ordemColetaPonto.ordemColetaExecucao[0].justificativa : null,
                        descricao: ordemColetaPonto.pontoColeta.logradouro + ", " + ordemColetaPonto.pontoColeta.numeroLogradouro + ", " + ordemColetaPonto.pontoColeta.bairro,
                        identificacao: ordemColetaPonto.pontoColeta.identificacao,
                        ordemColetaExecucao: _ordemColetaExecucao,
                        latitude: ordemColetaPonto.pontoColeta.latitude,
                        longitude: ordemColetaPonto.pontoColeta.longitude,
                        ordemColetaPontoColetaId: ordemColetaPonto.ordemColetaPontoColetaId,
                        ordemColetaAcaoColetorId: null,
                        ordemColetaPontoColetaAlteracoes: ordemColetaPonto?.ordemColetaExecucaoLogAlteracoes ?? []
                    });
                });
            }
            _acoes = _acoes.sort((a, b) => new Date(a.dataHoraExecucao) - new Date(b.dataHoraExecucao));
        }
        set_acoes(_acoes);
    }

    const [optionsJustificativas, setOptionsJustificativas] = useState([]);
    const loadJustificaticaModalidade = (modalidadeColetaId) => {
        api_GET(`Justificativa/GetByModalidadeId/${modalidadeColetaId}`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                result.data = result.data?.map((value) => {
                    value.label = value.descricao;
                    value.value = value.descricao;
                    return value;
                });
                setOptionsJustificativas(result.data);
            }
        });
    }

    const handleAltualizarjustificativa = (value, m) => {
        const _acoes = [...acoes];

        if (value != null && (m.tipoAcao == "Ocorrência" || m.tipoAcao == "Suspensão da Execução") && m.ordemColetaAcaoColetorId != null) {
            api_PUT(`OrdemColeta/UpdateordemColetaAcaoColetorJustificativa/${m.ordemColetaAcaoColetorId}/${value.justificativaId}`).then(result => {
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Sucesso", "Justificativa Atualizada com sucesso!", 'success', function () {
                        _acoes.map(value => {
                            if (value.ordemColetaAcaoColetorId != null && value.ordemColetaAcaoColetorId == m.ordemColetaAcaoColetorId) {
                                value.justificativa = result.data?.justificativa;
                                return value;
                            }
                            return value;
                        });
                        set_acoes(_acoes);
                    });
                }
            });
        } else if (value != null && (m.tipoAcao == "Execução Parcial" || m.tipoAcao == "Não Execução") && m.ordemColetaExecucao != null) {
            api_PUT(`OrdemColeta/UpdateOrdemColetaExecucaoJustificativa/${m.ordemColetaExecucao.ordemColetaExecucaoId}/${value.justificativaId}/${m.ordemColetaPontoColetaId}`).then(result => {
                if (result.status !== 204) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Sucesso", "Justificativa Atualizada com sucesso!", 'success', function () {
                        _acoes.map(_value => {
                            if (_value.ordemColetaExecucao != null && _value.ordemColetaExecucao.ordemColetaExecucaoId == m.ordemColetaExecucao.ordemColetaExecucaoId) {
                                _value.justificativa = value;
                                return _value;
                            }
                            return _value;
                        });
                        set_acoes(_acoes);
                    });
                }
            });
        }
    }

    useEffect(() => {
        if (stateModalAcoesColetor) {
            handleLoadAcoes();
            loadJustificaticaModalidade(ordemColeta.modalidadeColetaId);
        }
        setstateModal(stateModalAcoesColetor);
        loadoptionsQualidadeExecucao(ordemColeta.modalidadeColetaId)
    }, [stateModalAcoesColetor]);


    const handleObservacao = (ordemColetaAcaoColetor) => {
        if (ordemColetaAcaoColetor.observacao != null && ordemColetaAcaoColetor.observacao != "")
            return ordemColetaAcaoColetor.observacao;
        else if (ordemColetaAcaoColetor.tipoAcao == "Início da Execução")
            return "Para iniciar a execução, é necessário realizar registro fotográfico dos recursos utilizados na operação.";
        else if (ordemColetaAcaoColetor.tipoAcao == "Pausa da Execução")
            return "É necessário efetuar o registro fotográfico do veículo";
        else if (ordemColetaAcaoColetor.tipoAcao == "Reinício da Execução")
            return "Para reiniciar a execução é necessário tirar uma foto na seguinte situação: Equipamento de Coleta; Equipe de Coleta com EPI's; Equipamentos auxiliares disponíveis";
        else if (ordemColetaAcaoColetor.tipoAcao == "Suspensão da Execução")
            return "Para suspender a execução é necessário tirar uma foto do veículo e informar o motivo da suspensão";
        else if (ordemColetaAcaoColetor.tipoAcao == "Finalização Manual")
            return "Ordem de coleta finalizada manualmente pelo operador";
        else if (ordemColetaAcaoColetor.tipoAcao == "Finalização Automática")
            return "Ordem de coleta finalizada automaticamente pelo sistema";
        else if (ordemColetaAcaoColetor.tipoAcao == "Destinação")
            return "Para destinar, é necessário realizar registro fotográfico da caçamba lonada.";
        else if (ordemColetaAcaoColetor.tipoAcao == "Descarregar")
            return "Registro de QRCode do Comprovante de Descarregamento.";
        else return "";
    }

    const openImage = (image) => {
        window.open(session.pathVirtual + image);
    }

    const minutosParaTempo = (minutos) => {
        const totalHoras = Math.floor(minutos / 60);
        const totalMinutos = minutos % 60;
        const horas = totalHoras % 24; 
        const minutosRestantes = totalMinutos;
        const tempoFormatado = `${horas.toString().padStart(2, '0')}:${minutosRestantes.toString().padStart(2, '0')}`;
        return tempoFormatado;
    }

    const handleQualidadeExecucao = ({ condicao, configuracaoIndiceQualidadeCondicaoId }, ordemColetaExecucaoId, ordemColetaPontoColeta) => {
        setshowLoading(true);

        api_PUT('OrdemColeta/AtualizarQualidadeExecucao', {
            ordemColetaExecucaoId: ordemColetaExecucaoId,
            classificacao: condicao,
            configuracaoIndiceQualidadeCondicaoId: configuracaoIndiceQualidadeCondicaoId,
            ordemColetaPontoColetaId: ordemColetaPontoColeta.ordemColetaPontoColetaId
        })
            .then(result => {
                setshowLoading(false);
                if (result.status != 204) {
                    showMessage("Error", "Error na operação.", "error", null)
                    return;
                } else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', null);
                }
            });

        const _acoes = [...acoes];
        _acoes.map(value => {
            if (value.ordemColetaExecucao && value.ordemColetaExecucao.ordemColetaExecucaoId == ordemColetaExecucaoId) {
                value.ordemColetaExecucao.qualidadeExecucao = condicao;
                return value;
            }
            return value;
        });
        set_acoes(_acoes);
    }

    const [stateModal2ViaComprovanteDescarregamento, setStateModal2ViaComprovanteDescarregamento] = useState(false);
    const [comprovanteDescarregamento, setComprovanteDescarregamento] = useState(null);
    const [ordemColetaDestinacaoId, setOrdemColetaDestinacaoId] = useState(null);
    const handle2ViaComprovanteDescarregamento = (value) => {
        setOrdemColetaDestinacaoId(value.ordemColetaDestinacaoId)
        setStateModal2ViaComprovanteDescarregamento(true);
        setComprovanteDescarregamento(null);
    }

    const handleEditarComprovante = (value) => {
        setOrdemColetaDestinacaoId(value.ordemColetaDestinacaoId)
        setStateModal2ViaComprovanteDescarregamento(true);
        setComprovanteDescarregamento(value);
    }

    const [itemModalAddInconformidade, setitemModalAddInconformidade] = useState(null);
    const [stateModalInconformidade, setstateModalInconformidade] = useState(false);
    const handleAddInconformidade = (value) => {
        setitemModalAddInconformidade({ lat: value.latitude, lng: value.longitude })
        setstateModalInconformidade(true);
    }


    const optionsTipoAcao = [
        { value: "Execução Total", label: "Execução Total" },
        { value: "Execução Parcial", label: "Execução Parcial" },
        { value: "Não Execução", label: "Não Execução" },
    ]

    const handleAlteraTipoAcao = (e, ordemColetaPontoColeta) => {
        setshowLoading(true)
        api_PUT("ordemColeta/UpdateTipoAcaoOrdemColetaPontoColeta", { ordemColetaPontoColetaId: ordemColetaPontoColeta.ordemColetaPontoColetaId, tipoAcao: e.value }).then(result => {
            setshowLoading(false);
            if (result.status !== 204) {
                showMessage("Aviso", result.message, 'error', null);
                return;
            }
            else {
                showMessage("Atenção", "Atualizado com sucesso o tipo da ação!", 'success', null);
            }
        });

        const _acoes = [...acoes];
        _acoes.map(_ordemColetaPontoColeta => {
            if (_ordemColetaPontoColeta.ordemColetaPontoColetaId == ordemColetaPontoColeta.ordemColetaPontoColetaId) {
                _ordemColetaPontoColeta.tipoAcao = e.value;
                return _ordemColetaPontoColeta;
            } else {
                return _ordemColetaPontoColeta;
            }
        })

        set_acoes(_acoes);
    }

    const handleVoltarModalAcaoGestor = (value) => {
        if (value != null) {
            const _acoes = [...acoes];
            _acoes.map(_ordemColetaPontoColeta => {
                if (_ordemColetaPontoColeta.ordemColetaDestinacaoId == ordemColetaDestinacaoId) {
                    if (value.ordemColetaDestinacaoComprovanteId && _ordemColetaPontoColeta?.comprovantes?.length > 0 && _ordemColetaPontoColeta?.comprovantes.filter(x => x.ordemColetaDestinacaoComprovanteId == value.ordemColetaDestinacaoComprovanteId).length > 0) {
                        let comprovante = _ordemColetaPontoColeta?.comprovantes.filter(x => x.ordemColetaDestinacaoComprovanteId == value.ordemColetaDestinacaoComprovanteId)[0];
                        comprovante.placaVeiculoBalanca = value.placaVeiculoBalanca;
                        comprovante.dataHoraEntrada = value.dataHoraEntrada;
                        comprovante.dataHoraSaida = value.dataHoraSaida;
                        comprovante.pesoBruto = value.pesoBruto;
                        comprovante.tara = value.tara;
                        comprovante.pesoLiquido = value.pesoLiquido;
                        comprovante.tara = value.tara;
                        comprovante.dataHoraEdicao = value.dataHoraEdicao;
                        comprovante.arquivo = value.arquivo;
                        comprovante.usuario = value.usuario;
                        return comprovante;
                    } else {
                        _ordemColetaPontoColeta.comprovantes.push(value)
                        return _ordemColetaPontoColeta;
                    }
                } else {
                    return _ordemColetaPontoColeta;
                }
            })
            set_acoes(_acoes);
        }
        setStateModal2ViaComprovanteDescarregamento(false);
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label style={{ marginRight: "20px" }}>Carregando...</label>
                        <Spinner size="sm" color="info" />
                    </div>
                </div>
            }
            {!stateModal2ViaComprovanteDescarregamento && !stateModalInconformidade &&
                <Modal
                    className="modal-dialog-centered allowPrint"
                    isOpen={stateModal}
                    size="lg"
                    toggle={() => handleReturn()}
                >
                    <div className="modal-header">
                        <h4 className="modal-title" id="modal-title-default">
                            Ações do Coletor
                        </h4>
                        <button
                            aria-label="Close"
                            className="close no-print"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => handleReturn()}
                        >
                            <span aria-hidden={true}>×</span>
                        </button>
                    </div>
                    <div className="modal-body" ref={refImprimir} >
                        <div className={`${ordemColetaAcaoColetorId ? "d-none" : ""}`}>
                            {ordemColeta && ordemColeta.statusExecucaoOrdemColeta == "Finalizada" &&
                                <div class={`d-flex justify-content-end mb-1`}>
                                    <div className={`d-flex`}>
                                        <div className="text-center font-weight-bold">
                                            <div class="px-2 d-flex justify-content-end ">Status de Avaliação</div>
                                            <div class="px-2 d-flex justify-content-end">Índice de Atendimento </div>
                                            <div class="px-2 d-flex justify-content-end">Qualidade de Execução </div>
                                        </div>
                                        <div className="text-center">
                                            <div style={{ background: ordemColeta.statusAvaliacaoOrdemColeta == "Aprovada" ? "#2ecc71" : ordemColeta.statusAvaliacaoOrdemColeta == "Reprovada" ? "#e74c3c" : "#505858", fontWeight: "bold", color: ordemColeta.statusAvaliacaoOrdemColeta == "Não Avaliada" ? "black" : "white" }} className="px-2">{ordemColeta.statusAvaliacaoOrdemColeta}</div>
                                            <div style={{ background: ordemColeta?.corIndiceAtendimento, fontWeight: "bold", color: "white" }} className="px-2">{ordemColeta?.indiceAtendimento}% {ordemColeta?.condicaoIndiceAtendimento}</div>
                                            <div style={{ background: ordemColeta?.corIndiceQualidade, fontWeight: "bold", color: "white" }} class="px-2  text-white">{ordemColeta?.indiceQualidadeExecucao}% {ordemColeta?.condicaoIndiceQualidade}</div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <Row >
                                <Col md={12} lg={12}>
                                    <span className="font-weight-bold">Concessionária: </span><span>{ordemColeta?.concessionaria?.identificacao}</span>
                                </Col>
                                {ordemColeta?.setorColeta != null &&
                                    <Col md={12} lg={12}>
                                        <span className="font-weight-bold">Plano de Trabalho: </span> <span>{ordemColeta?.setorColeta?.descricao}</span>
                                    </Col>
                                }
                                <Col md={12} lg={12}>
                                    <span className="font-weight-bold">Modalidade de Serviço: </span><span>{ordemColeta?.modalidadeColeta?.descricao}</span>
                                </Col>
                                <Col md={12} lg={12}>
                                    <span className="font-weight-bold">Recurso: </span><span>{ordemColeta?.veiculo?.placa}</span>
                                </Col>
                                <Col md={12} lg={12}>
                                    <span className="font-weight-bold">Operador: </span><span>{ordemColeta?.usuarioOperadorColeta?.nome}</span>
                                </Col>
                                <Col md={12} lg={12}>
                                    <span className="font-weight-bold">Status da Ordem: </span><span>{ordemColeta?.statusExecucaoOrdemColeta}</span>
                                </Col>
                                <Col md={12} lg={12}>
                                    <span className="font-weight-bold">Início da execução: </span><span>{moment(ordemColeta?.dataInicioExecucao).format("DD/MM/YYYY HH:mm")}</span>
                                </Col>
                                <Col md={12} lg={12}>
                                    <span className="font-weight-bold">Fim da execução: </span><span>{ordemColeta?.statusExecucaoOrdemColeta == "Finalizada" ? moment(ordemColeta?.dataFimExecucao).format("DD/MM/YYYY HH:mm") : ""}</span>
                                </Col>
                                <Col md={12} lg={12}>
                                    <span className="font-weight-bold">Tempo de Execução da Ordem de Serviço: </span><span>{ordemColeta?.statusExecucaoOrdemColeta == "Finalizada" ? minutosParaTempo(ordemColeta?.tempoExecucaoMinutos) : ""}</span>
                                </Col>
                                <Col md={12} lg={12}>
                                    <span className="font-weight-bold">Tempo de Atuação nos Locais de Execução: </span><span>{ordemColeta?.statusExecucaoOrdemColeta == "Finalizada" ? minutosParaTempo(ordemColeta?.tempoMedioLocalExecucao) : ""}</span>
                                </Col>
                                <Col md={12} lg={12}>
                                    <span className="font-weight-bold">Rastreamento: </span><span>{ordemColeta?.statusExecucaoOrdemColeta == "Finalizada" ? ordemColeta?.origemRastreio : ""}</span>
                                </Col>
                                <Col md={12} lg={12}>
                                    <span className="font-weight-bold">Total Percorrido: </span><span>{ordemColeta?.statusExecucaoOrdemColeta == "Finalizada" ? ordemColeta?.quilometragemPercorrida : ""}</span>
                                </Col>
                            </Row>
                        </div>
                        {acoes && acoes.length > 0 && acoes.map((m, index) => {
                            return <div key={index} className="page-break">
                                <Row style={{
                                    borderBottom: "1px solid #ccc",
                                    paddingTop: "10px"
                                }}>
                                    {(session.perfil == "Gestor" || session.perfil == "Master" || session.perfil == "Encarregado de Monitoramento") &&
                                        (m.tipoAcao == "Execução Total" || m.tipoAcao == "Execução Parcial" || m.tipoAcao == "Não Execução") &&
                                        (ordemColeta.statusAvaliacaoOrdemColeta != "Aprovada" && ordemColeta.statusAvaliacaoOrdemColeta != "Reprovada") ?
                                        <Col md="6">
                                            <FormGroup className="mb-0">
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    Ação
                                                </label>
                                                <Select
                                                    options={optionsTipoAcao}
                                                    name="acao"
                                                    onChange={(value) => { handleAlteraTipoAcao(value, m) }}
                                                    value={optionsTipoAcao.find(x => x.value == m.tipoAcao)}
                                                    placeholder="Selecione Ação"
                                                />
                                            </FormGroup>
                                        </Col>
                                        :
                                        <Col md="6">
                                            <FormGroup className="mb-0">
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    Ação
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    name="acao"
                                                    type="text"
                                                    value={m != null && m.tipoAcao}
                                                    disabled="true"
                                                />
                                            </FormGroup>
                                        </Col>
                                    }
                                    <Col md="6">
                                        <FormGroup className="mb-0">
                                            <label className="form-control-label" htmlFor="input-address" >
                                                Data/Hora
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                name="acao"
                                                type="text"
                                                value={m != null && formateDateandTime(m.dataHoraExecucao)}
                                                disabled="true"
                                            />
                                        </FormGroup>
                                    </Col>
                                    {m.ordemColetaExecucao && m.ordemColetaPontoColetaAlteracoes?.length > 0 && m.ordemColetaPontoColetaAlteracoes.filter(x => x.tipoalteracao == "Execução")?.length > 0 &&
                                        <Col md="6">
                                            <p className="mb-0" style={{ fontSize: "0.75rem" }}>Atualizado por {m.ordemColetaPontoColetaAlteracoes.filter(x => x.tipoalteracao == "Execução")[0]?.usuarioAtualizacao?.nome} em {moment(m.ordemColetaPontoColetaAlteracoes.filter(x => x.tipoalteracao == "Execução")[0].dataHoraAtualizacao).format("DD/MM/YYYY HH:mm")}</p>
                                        </Col>
                                    }
                                    {m.justificativa &&
                                        (m.tipoAcao === "Suspensão da Execução" || m.tipoAcao === "Não Execução" || m.tipoAcao === "Ocorrência" || m.tipoAcao === "Execução Parcial") &&
                                        (((session.perfil === "Gestor" || session.perfil === "Master" || session.perfil == "Encarregado de Monitoramento") &&
                                            (ordemColeta.statusAvaliacaoOrdemColeta == "Aprovada" || ordemColeta.statusAvaliacaoOrdemColeta == "Reprovada")) ||
                                            (session.perfil !== "Gestor" && session.perfil !== "Master" && session.perfil !== "Encarregado de Monitoramento")) &&
                                        <Col md="12" className="mt-1">
                                            <FormGroup className="mb-0">
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    Justificativa
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    name="justificativa"
                                                    type="text"
                                                    value={m?.justificativa?.descricao}
                                                    disabled="true"
                                                />
                                            </FormGroup>
                                        </Col>
                                    }

                                    {m.justificativa && optionsJustificativas.length > 0 &&
                                        (m.tipoAcao === "Suspensão da Execução" || m.tipoAcao === "Não Execução" || m.tipoAcao === "Ocorrência" || m.tipoAcao === "Execução Parcial") &&
                                        (session.perfil === "Gestor" || session.perfil === "Master" || session.perfil == "Encarregado de Monitoramento") &&
                                        (ordemColeta.statusAvaliacaoOrdemColeta != "Aprovada" && ordemColeta.statusAvaliacaoOrdemColeta != "Reprovada") && (
                                            <Col md="12" className="mt-1">
                                                <FormGroup className="mb-0">
                                                    <label className="form-control-label">
                                                        Justificativa
                                                    </label>
                                                    <Select
                                                        options={optionsJustificativas?.filter(x =>
                                                            (m.tipoAcao === "Execução Parcial" && x.coletaParcial) ||
                                                            (m.tipoAcao === "Não Execução" && x.naoColeta) ||
                                                            (m.tipoAcao === "Ocorrência" && x.registroOcorrencia) ||
                                                            (m.tipoAcao === "Suspensão da Execução" && x.suspensaoOS)
                                                        )}
                                                        name="justificativa"
                                                        onChange={(value) => { handleAltualizarjustificativa(value, m) }}
                                                        value={optionsJustificativas.length > 0 &&
                                                            optionsJustificativas.find(x => x.descricao === m.justificativa?.descricao)
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                        )}

                                    {m.ordemColetaExecucao && m.ordemColetaPontoColetaAlteracoes?.length > 0 && m.ordemColetaPontoColetaAlteracoes.filter(x => x.tipoalteracao == "Justificativa")?.length > 0 ?
                                        <Col md="6">
                                            <p className="mb-0" style={{ fontSize: "0.75rem" }}>Atualizado por {m.ordemColetaPontoColetaAlteracoes.filter(x => x.tipoalteracao == "Justificativa")[0]?.usuarioAtualizacao?.nome} em {moment(m.ordemColetaPontoColetaAlteracoes.filter(x => x.tipoalteracao == "Justificativa")[0].dataHoraAtualizacao).format("DD/MM/YYYY HH:mm")}</p>
                                        </Col>
                                        : m.ordemColetaAcaoColetorLogAlteracao && m.ordemColetaAcaoColetorLogAlteracao?.length > 0 && m.ordemColetaAcaoColetorLogAlteracao.filter(x => x.tipoalteracao == "Justificativa")?.length > 0 ?
                                            <Col md="6">
                                                <p className="mb-0" style={{ fontSize: "0.75rem" }}>Atualizado por {m.ordemColetaAcaoColetorLogAlteracao.filter(x => x.tipoalteracao == "Justificativa")[0]?.usuarioAtualizacao?.nome} em {moment(m.ordemColetaAcaoColetorLogAlteracao.filter(x => x.tipoalteracao == "Justificativa")[0].dataHoraAtualizacao).format("DD/MM/YYYY HH:mm")}</p>
                                            </Col>
                                            : null
                                    }

                                    <Col md="12" className="mt-1">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                {(m.tipoAcao == "Execução Total" || m.tipoAcao == "Execução Parcial" || m.tipo == "Não Execução" || m.tipo == "Execução Iniciada") ? "Endereço" : "Descrição"}
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                name="observacao"
                                                type="textarea"
                                                value={m.descricao}
                                                disabled="true"
                                            />
                                        </FormGroup>
                                    </Col>
                                    {!!m.identificacao &&
                                        <Col md="12">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    Identificação
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    name="identificacao"
                                                    type="text"
                                                    value={m.identificacao}
                                                    disabled="true"
                                                />
                                            </FormGroup>
                                        </Col>
                                    }

                                    {m.ordemColetaExecucao && m.ordemColetaExecucao.evidenciasAntes.length > 0 &&
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    Evidências Antes
                                                </label>
                                                <br />
                                                {m.ordemColetaExecucao.evidenciasAntes.map((n, keyAntes) => {
                                                    return <div style={{ display: "inline-block", textAlign: "center" }} key={keyAntes}>
                                                        <img
                                                            alt={"..."}
                                                            height="140"
                                                            className="mb-2 mr-2 d-inline"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => openImage(n.arquivo)}
                                                            src={session.pathVirtual + n.arquivo}
                                                        />
                                                        <figcaption style={{ fontSize: "11px" }}>{moment(n.dataHoraArquivo).format("DD/MM/YYYY HH:mm:ss")}</figcaption>
                                                    </div>
                                                }
                                                )}
                                            </FormGroup>
                                        </Col>
                                    }
                                    {m.ordemColetaExecucao && m.ordemColetaExecucao.evidenciasDepois.length > 0 &&
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    Evidências Depois
                                                </label>
                                                <br />
                                                {m.ordemColetaExecucao.evidenciasDepois.map((n, keyDepois) => {
                                                    return <div style={{ display: "inline-block", textAlign: "center" }} ke={keyDepois}>
                                                        <img
                                                            alt={"..."}
                                                            height="140"
                                                            className="mb-2 mr-2"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => openImage(n.arquivo)}
                                                            src={session.pathVirtual + n.arquivo}
                                                        />
                                                        <figcaption style={{ fontSize: "11px" }}>{moment(n.dataHoraArquivo).format("DD/MM/YYYY HH:mm:ss")}</figcaption>
                                                    </div>
                                                }
                                                )}
                                            </FormGroup>
                                        </Col>
                                    }
                                    {m.ordemColetaExecucao && m.ordemColetaExecucao.evidenciasDepois.length > 0 && m.ordemColetaExecucao.evidenciasAntes.length > 0 &&
                                        <Col md="12">
                                            <p>
                                                {m.ordemColetaExecucao && m.ordemColetaExecucao.tempoExecucaoMinutos != null ? `Tempo de atuação no local de execução ${minutosParaTempo(m.ordemColetaExecucao.tempoExecucaoMinutos)}` : ""}
                                            </p>
                                        </Col>
                                    }
                                    {(session.perfil == "Gestor" || session.perfil == "Master" || session.perfil == "Encarregado de Monitoramento") &&
                                        (m.tipoAcao == "Execução Total" || m.tipoAcao == "Execução Parcial") &&
                                        (ordemColeta.statusAvaliacaoOrdemColeta != "Aprovada" && ordemColeta.statusAvaliacaoOrdemColeta != "Reprovada") &&
                                        <Col md="4" lg="4" style={{ zIndex: 99999 }}>
                                            <FormGroup className="mb-1">
                                                <label className="form-control-label">
                                                    Qualidade da Execução
                                                </label>
                                                <Select
                                                    options={optionsQualidadeExecucao}
                                                    name="qualidadeExecucao"
                                                    getOptionLabel={({ condicao }) => condicao}
                                                    getOptionValue={({ condicao }) => condicao}
                                                    onChange={(value) => handleQualidadeExecucao(value, m.ordemColetaExecucao.ordemColetaExecucaoId, m)}
                                                    value={m.ordemColetaExecucao && m.ordemColetaExecucao.qualidadeExecucao && optionsQualidadeExecucao.find(x => x.condicao == m.ordemColetaExecucao.qualidadeExecucao)}
                                                    placeholder="Selecione"
                                                />
                                            </FormGroup>
                                        </Col>
                                    }

                                    {(m.tipoAcao === "Execução Total" || m.tipoAcao === "Execução Parcial") &&
                                        (((session.perfil === "Gestor" || session.perfil === "Master" || session.perfil == "Encarregado de Monitoramento") &&
                                            (ordemColeta.statusAvaliacaoOrdemColeta === "Aprovada" || ordemColeta.statusAvaliacaoOrdemColeta === "Reprovada")) ||
                                            (session.perfil !== "Gestor" && session.perfil !== "Master" && session.perfil !== "Encarregado de Monitoramento")) &&
                                        <Col md="4" lg="4" >
                                            <FormGroup className="mb-1">
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    Qualidade da Execução
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    name="observacao"
                                                    type="text"
                                                    value={m.ordemColetaExecucao && m.ordemColetaExecucao.qualidadeExecucao}
                                                    disabled="true"
                                                />
                                            </FormGroup>
                                        </Col>
                                    }

                                    {m.ordemColetaExecucao && m.ordemColetaPontoColetaAlteracoes?.length > 0 && m.ordemColetaPontoColetaAlteracoes.filter(x => x.tipoalteracao == "Qualidade")?.length > 0 &&
                                        <Col md="6" lg="12">
                                            <p className="mb-0" style={{ fontSize: "0.75rem" }}>Atualizado por {m.ordemColetaPontoColetaAlteracoes.filter(x => x.tipoalteracao == "Qualidade")[0]?.usuarioAtualizacao?.nome} em {moment(m.ordemColetaPontoColetaAlteracoes.filter(x => x.tipoalteracao == "Qualidade")[0].dataHoraAtualizacao).format("DD/MM/YYYY HH:mm")}</p>
                                        </Col>
                                    }

                                    {m.evidenciasAcao && m.evidenciasAcao.length > 0 &&
                                        <Col md="12" className="mt-2">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    Evidências
                                                </label>
                                                <br />
                                                <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                                                    {m.evidenciasAcao.map((n, key) => {
                                                        return <div style={{ display: "inline-block", textAlign: "center" }} key={n.dataHoraArquivo}>
                                                            <img
                                                                alt={"..."}
                                                                height="140"
                                                                className="mb-2 mr-2"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => openImage(n.arquivo)}
                                                                src={session.pathVirtual + n.arquivo}
                                                            />
                                                            <figcaption style={{ fontSize: "11px" }}>{formateDateandTime(n.dataHoraArquivo)}</figcaption>
                                                        </div>
                                                    }
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    }
                                    {(m.tipoAcao === "Descarregar" || m.tipoAcao == "Descarregar Sem Comprovante") &&
                                        (ordemColeta.statusAvaliacaoOrdemColeta != "Aprovada" && ordemColeta.statusAvaliacaoOrdemColeta != "Reprovada") &&
                                        <Col lg="12" className="mb-2 d-flex justify-content-end">
                                            <Button color="primary" className="text-right btn-invisivel" onClick={() => handle2ViaComprovanteDescarregamento(m)}>
                                                <FontAwesomeIcon icon={faPlus} /> Adicionar 2ª via de Comprovante de descarregamento
                                            </Button>
                                        </Col>
                                    }
                                    {(m.tipoAcao === "Descarregar" || m.tipoAcao == "Descarregar Sem Comprovante") && m.comprovantes.length > 0
                                        ?
                                        <Col lg="12" className="mb-3">
                                            <div style={{ overflowX: 'auto' }}>
                                                <table className="table table-striped" style={{ maxWidth: '100%', borderCollapse: 'collapse' }}>
                                                    <thead>
                                                        <tr>
                                                            <th className="Column-table">
                                                                AÇÕES
                                                            </th>
                                                            <th>
                                                                PLACA
                                                            </th>
                                                            <th>
                                                                DATA/HORA - ENTRADA
                                                            </th>
                                                            <th>
                                                                DATA/HORA - SAÍDA
                                                            </th>
                                                            <th>
                                                                PESO BRUTO TOTAL
                                                            </th>
                                                            <th>
                                                                TARA
                                                            </th>
                                                            <th>
                                                                PESO LÍQUIDO
                                                            </th>
                                                            <th>
                                                                USUÁRIO ATUALIZAÇÃO
                                                            </th>
                                                            <th>
                                                                DATA/HORA
                                                            </th>
                                                            <th className="Column-table">
                                                                ARQUIVO
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {m.comprovantes.map((value, index) => (
                                                            <tr key={index}>
                                                                <td className="Column-table">
                                                                    {ordemColeta.statusAvaliacaoOrdemColeta !== "Aprovada" && ordemColeta.statusAvaliacaoOrdemColeta !== "Reprovada" && (
                                                                        <Button color="warning" style={{ padding: '5px 10px' }} onClick={() => handleEditarComprovante(value)}>
                                                                            <FontAwesomeIcon icon={faPen} />
                                                                        </Button>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {value.placaVeiculoBalanca}
                                                                </td>
                                                                <td>
                                                                    {formateDateandTime(value.dataHoraEntrada)}
                                                                </td>
                                                                <td>
                                                                    {formateDateandTime(value.dataHoraSaida)}
                                                                </td>
                                                                <td>
                                                                    {new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value.pesoBruto)}
                                                                </td>
                                                                <td>
                                                                    {new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value.tara)}
                                                                </td>
                                                                <td>
                                                                    {new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value.pesoLiquido)}
                                                                </td>
                                                                <td>
                                                                    {value.usuario && value.usuario.nome}
                                                                </td>
                                                                <td>
                                                                    {value.dataHoraEdicao && moment(value.dataHoraEdicao).format("DD/MM/YYYY HH:mm:ss")}
                                                                </td>
                                                                <td className="Column-table">
                                                                    {value.arquivo != null && <a href={session.pathVirtual + value.arquivo} target="_blank">Anexo</a>}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Col>
                                        :
                                        null
                                    }
                                    {ordemColeta.statusAvaliacaoOrdemColeta != "Aprovada" && ordemColeta.statusAvaliacaoOrdemColeta != "Reprovada" &&
                                        <Col md="12" className="mt-2 mb-3 btn-invisivel">
                                            <Button onClick={() => handleAddInconformidade(m)}><FontAwesomeIcon icon={faSquarePlus} />  Adicionar Inconformidade</Button>
                                        </Col>
                                    }
                                </Row>
                            </div>
                        })}
                        <div className='print w-100' style={{ display: "none" }}>
                            <p className='font-weight-bold text-right'>Gerado em {moment().format("DD/MM/YYYY HH:mm")}, Por {session?.nome}.</p>
                        </div>
                    </div>
                    <div className="modal-footer no-print">
                        <Button color="secondary" type="button" onClick={() => handleReturn()}>
                            Fechar
                        </Button>
                        <Button color="danger" type="button" onClick={handlePrint}>
                            Imprimir
                        </Button>
                    </div>
                </Modal>
            }
            {stateModal2ViaComprovanteDescarregamento &&
                <ModalViaComprovanteDescarregamento
                    ordemColeta={ordemColeta}
                    comprovanteDescarregamento={comprovanteDescarregamento}
                    ordemColetaDestinacaoId={ordemColetaDestinacaoId}
                    handleReturn={(data) => handleVoltarModalAcaoGestor(data)}
                    stateModal2ViaComprovante={stateModal2ViaComprovanteDescarregamento}
                    setshowLoading={setshowLoading}
                />
            }
            {stateModalInconformidade &&
                <ModalAdicionarInconformidade
                    stateModalInconformidade={stateModalInconformidade}
                    item={itemModalAddInconformidade}
                    ordemColeta={ordemColeta}
                    handleReturn={() => handleReturn()}
                    showLoading={setshowLoading}
                />
            }
        </>
    );
}